// extracted by mini-css-extract-plugin
export default {"groupContainer":"Thought_groupContainer__vA-A7"};